import * as React from 'react'
import isBrowser from 'services/isBrowser';

export const useFadeVisibility = (scrollRef: any, mouseUpHandler: any) => {
    const getFadeVisibility = () => {
        return {
            left: scrollRef?.current?.scrollLeft > 4,
            right: scrollRef?.current?.scrollLeft + scrollRef?.current?.clientWidth + 4 < scrollRef?.current?.scrollWidth
        }
    }

    const [fadeVisible, setFadeVisible] = React.useState<{ left: boolean, right: boolean }>(getFadeVisibility())


    React.useEffect(()=>{
        setFadeVisible(getFadeVisibility())
        if (!isBrowser()) return;
        window.addEventListener('resize', () => setFadeVisible(getFadeVisibility()))
        let interval: any = null;
            interval = setInterval(() => {
                setFadeVisible(getFadeVisibility())
            }, 300)
        return () => {
            window.removeEventListener('resize', () => setFadeVisible(getFadeVisibility()));
            if (interval) {
                clearInterval(interval)
            }
        }

    }, [scrollRef])



    const mouseReleaseHandler = () => {
        mouseUpHandler()
        setFadeVisible(getFadeVisibility())
    }


    


    return {fadeVisible, mouseReleaseHandler}

}